import classNames from "classnames";
import React from "react";
import { WrappedFieldProps } from "redux-form";

import Checkbox from "features/common/components/Checkbox";

import "./FormCheckbox.scss";

type Props = WrappedFieldProps & {
  label?: string;
  wrapperClass?: string;
  pulse?: boolean;
  text?: string;
  checkboxWrapperClassName?: string;
  defaultValue?: boolean;
};

export default class FormCheckbox extends React.PureComponent<Props> {
  _handleChange = () => {
    const { value, onChange } = this.props.input;
    onChange(!value);
  };

  render() {
    const {
      defaultValue = false,
      label,
      wrapperClass,
      input: { value },
      pulse,
      checkboxWrapperClassName
    } = this.props;
    const error = this.props.meta.error && this.props.meta.submitFailed;

    return (
      <div
        className={classNames("FormCheckbox", wrapperClass, {
          "FormCheckbox--error": error,
          "FormCheckbox--pulseError": error && pulse
        })}
      >
        <Checkbox
          selected={value !== "" ? value : defaultValue}
          onChange={this._handleChange}
          text={label}
          checkboxClassName="FormCheckbox__checkBox"
          className={checkboxWrapperClassName}
        />
        {error && (
          <p className="FormCheckbox__error">{this.props.meta.error}</p>
        )}
      </div>
    );
  }
}
